export const isValidEmail = (email) => {
	const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,}$/i

	if (emailRegex.test(email)) {
		return true
	} else {
		return false
	}
}